var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_98443",
    "data-name": "Group 98443",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27639054"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5254",
    "data-name": "Rectangle 5254",
    width: 15,
    height: 18,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26937",
    "data-name": "Group 26937",
    clipPath: "url(#clip-path-27639054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62326",
    "data-name": "Path 62326",
    d: "M5.25,12.75v1.5a.75.75,0,1,1-1.5,0v-1.5a.75.75,0,1,1,1.5,0M10.5,10.5a.75.75,0,0,0-.75.75v3a.75.75,0,1,0,1.5,0v-3a.75.75,0,0,0-.75-.75m-3-2.25A.75.75,0,0,0,6.75,9v5.25a.75.75,0,1,0,1.5,0V9a.75.75,0,0,0-.75-.75M15,7.864V14.25A3.754,3.754,0,0,1,11.25,18H3.75A3.754,3.754,0,0,1,0,14.25V3.75A3.754,3.754,0,0,1,3.75,0H7.136a5.218,5.218,0,0,1,3.712,1.537l2.613,2.614A5.214,5.214,0,0,1,15,7.864ZM9.788,2.6A3.759,3.759,0,0,0,9,1.994V5.25A.751.751,0,0,0,9.75,6h3.256a3.8,3.8,0,0,0-.6-.787L9.789,2.6ZM13.5,7.864c0-.122-.006-.244-.017-.364H9.75A2.253,2.253,0,0,1,7.5,5.25V1.517c-.12-.011-.241-.017-.364-.017H3.75A2.253,2.253,0,0,0,1.5,3.75v10.5A2.253,2.253,0,0,0,3.75,16.5h7.5a2.253,2.253,0,0,0,2.25-2.25Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenuIcon);
export default __webpack_public_path__ + "static/media/dashboard-menu-icon.e0c393c5373f5508b7c07d6fb5297d9e.svg";
export { ForwardRef as ReactComponent };